import { z } from 'zod';

/**
 * API-sleutels zoals ze over de lijn komen (`Identity\ApiKeyResource`).
 *
 * Het geheim zelf (`key`) staat er alleen in het antwoord op het aanmaken; daarna
 * nooit meer. `token_hint` zijn de laatste vier tekens, om een sleutel te herkennen.
 */
const timestamp = z.string();

const personSchema = z.object({ uuid: z.string(), name: z.string() });

export const apiKeyResourceSchema = z.object({
    uuid: z.string(),
    name: z.string(),
    scopes: z.array(z.string()),
    scope_labels: z.array(z.string()),
    prefix: z.string(),
    token_hint: z.string(),
    state: z.enum(['active', 'expired', 'revoked']),
    created_by: personSchema,
    created_at: timestamp.nullable(),
    expires_at: timestamp.nullable(),
    last_used_at: timestamp.nullable(),
    revoked_at: timestamp.nullable(),
    revoked_by: personSchema.nullable(),
    key: z.string().optional(),
});

export type ApiKeyResource = z.infer<typeof apiKeyResourceSchema>;

/** De adressen die een koppeling nodig heeft, in `meta` van de lijst en van het aanmaken. */
export const integrationAddressesSchema = z.object({
    mcp_url: z.string(),
    openapi_url: z.string(),
    docs_url: z.string(),
});

export const apiKeyListSchema = z.object({
    data: z.array(apiKeyResourceSchema),
    meta: integrationAddressesSchema,
});

export const createdApiKeySchema = z.object({
    data: apiKeyResourceSchema,
    meta: integrationAddressesSchema,
});

/** Eén regel uit het auditlog van een sleutel (`Platform\AuditLogResource`). */
export const apiKeyActivityResourceSchema = z.object({
    uuid: z.string().nullable(),
    event: z.string().nullable(),
    description: z.string(),
    created_at: timestamp.nullable(),
});

export type ApiKeyActivityResource = z.infer<typeof apiKeyActivityResourceSchema>;
